import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { CreditCards } from '../../../types';
import { Grid } from '../../../../CommonComponents/OPL/Grid/Grid';
import { Row } from '../../../../CommonComponents/OPL/Grid/Row';
import { Column } from '../../../../CommonComponents/OPL/Grid/Column';
import { Input } from '../../../../CommonComponents/OPL/Input/Input';
import { usePaymentQuery } from '../../../api/usePaymentQuery';
import getImagePath from '../../../../CommonUtils/getImagePath';

export const CreditCardSaved: React.FC = () => {
  const { data } = usePaymentQuery();

  if (!data) {
    return null;
  }

  const { maskedNumber } = data;

  return (
    <>
      <Box display="flex" alignItems="center" mb="16">
        <Text fontSize="h6" fontWeight={600}>
          Credit Card
        </Text>

        {Object.values(CreditCards).map(value => (
          <img
            key={value}
            src={getImagePath(`payment/${value}.jpg`)}
            alt={value}
            css={`
              height: 24px;
              margin-left: 8px;
            `}
          />
        ))}
      </Box>

      <Grid>
        <Row>
          <Column width={12}>
            <Input
              label="Card Number"
              value={maskedNumber || ''}
              disabled
              type="text"
              placeholder="Card Number"
              mb="16"
            />
          </Column>
        </Row>
      </Grid>

      <Grid>
        <Row>
          <Column width={4}>
            <Input label="CVV" value="***" disabled type="text" placeholder="CVV" />
          </Column>
        </Row>
      </Grid>
    </>
  );
};
